module.exports = __webpack_public_path__ + "static/media/front-card.54dfa2ef.svg";